import moment from "moment";
import { compose } from "redux";
import { connect } from "react-redux";
import { Grid } from "@material-ui/core";
import React, { PureComponent } from "react";
import People from "@material-ui/icons/People";
import { withStyles } from "@material-ui/core/styles";

import { Format } from "app/app.constants";
import BasePage from "app/components/BasePage";
import { formatDate } from "utils/format.util";
import { getActionDataStateFromState } from "app/app.selectors";
import NoContentBasePage from "app/components/NoContentBasePage";
import { ACTIONS } from "features/planner/report/report.constants";
import { getPOBReport } from "features/planner/report/report.actions";
import { getPOBReportFromState } from "features/planner/report/report.selectors";
import POBReportGroup from "features/planner/report/people-on-board/components/POBReportGroup";

class POBReportContainer extends PureComponent {
  componentDidMount() {
    const { dispatchOnLoad } = this.props;
    dispatchOnLoad();
  }

  render() {
    const { breadcrumb, dataState, pobReport, classes } = this.props;

    if (!pobReport.size && dataState.isLoading()) {
      return (
        <NoContentBasePage
          Icon={People}
          title={breadcrumb}
          header="People on Board"
          description="There are currently no employees deployed offshore"
        />
      );
    }

    return (
      <BasePage
        title={breadcrumb}
        dataState={dataState}
        subTitle={formatDate(moment(), Format.pobReport)}
      >
        <Grid container spacing={4} className={classes.root}>
          {pobReport.map(installation => (
            <POBReportGroup
              key={installation.get("groupId")}
              groupId={installation.get("groupId")}
            />
          ))}
        </Grid>
      </BasePage>
    );
  }
}

const styles = () => ({
  root: {
    display: "block",
  },
});

export default compose(
  connect(
    state => ({
      pobReport: getPOBReportFromState(state),
      dataState: getActionDataStateFromState(state, ACTIONS.GET_POB_REPORT),
    }),
    {
      dispatchOnLoad: getPOBReport,
    },
  ),
  withStyles(styles),
)(POBReportContainer);
